import { auth } from './firebase';
import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { getDatabase, ref, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import './RegisterPage.css';

function RegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(''); // New state for confirm password
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault(); // Prevent page reload

    // --- Start of New Validation Logic ---

    // 1. Check if passwords match
    if (password !== confirmPassword) {
      setMessage('Passwords do not match. Please try again.');
      return;
    }

    // 2. Check for password complexity (at least 6 chars, with letters and numbers)
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
    if (!passwordRegex.test(password)) {
      setMessage('Password must be at least 6 characters long and include both letters and numbers.');
      return;
    }
    
    // --- End of New Validation Logic ---

    setMessage(''); // Clear any previous error messages
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        const db = getDatabase();
        const userRef = ref(db, `users/${user.uid}`);
        
        // Save user data without the 'major' field
        return set(userRef, {
          email: email,
          uid: user.uid,
        });
      })
      .then(() => {
        navigate('/mentorai'); // Redirect after successful registration
      })
      .catch((error) => {
        switch (error.code) {
          case 'auth/email-already-in-use':
            setMessage('This email address is already registered.');
            break;
          case 'auth/invalid-email':
            setMessage('Please enter a valid email address.');
            break;
          default:
            setMessage(`Registration failed: ${error.message}`);
            break;
        }
      });
  };

  return (
    <div className="login-page">
      <header className="header">
        <div className="contact-info">
          For any queries, contact us at <a href="mailto:contact@coursehubofficial.com">contact@coursehubofficial.com</a>
        </div>
        <div className="top-links">
          <a href="about.html">About</a>
          <a href="info.html">Info</a>
        </div>
      </header>

      <main className="main-container">
        <div className="content-wrapper">
          <div className="hero-section">
            <div className="logo">CourseHub</div>
            <h1>Your portal to connecting to Students US wide</h1>
            <p>Unlock the power of AI with CourseHub and elevate your learning experience.</p>
          </div>

          <div className="auth-section">
            <form onSubmit={handleRegister}>
              <h2 className="auth-title">Create an Account</h2>
              <input
                className="login-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Email"
                required
              />
              <input
                className="login-input"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Password"
                required
              />
              {/* New "Confirm Password" input field */}
              <input
                className="login-input"
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Confirm Password"
                required
              />
              
              {message && <div className="error-message">{message}</div>}

              {/* Button now uses the new 'register-action-button' class */}
              <button type="submit" className="register-action-button">
                Register
              </button>

              <div className="auth-switch">
                Already have an account? <a href="/">Log In</a>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
}

export default RegisterPage;